import { useState } from "react";
import { CalculadoraFGTSInputCard } from "./components/CalculadoraFGTSInputCard";
import { CalculoFGTSResponse } from "./calcular-fgts";
import { CalculadoraFGTSResponse } from "./components/CalculadoraFGTSresponse";


export default function CalculadoraFGTS() {
    const [results, setResults] = useState<CalculoFGTSResponse | null>(null);

    return (
        <>
            <CalculadoraFGTSInputCard setResults={setResults} />
            {results && <CalculadoraFGTSResponse results={results} />}
        </>
    );
}
